import PropTypes from 'prop-types';

import { ProgressMultiItem } from 'twyne-new.ui';

const propTypes = {
  index: PropTypes.number,
  value: PropTypes.number,
  label: PropTypes.string,
  onClick: PropTypes.func,
}

export default function ProgressBar({ value, label, ...props }) {
  const maxChars = Math.max(1, Math.floor((value * 150) / 100))
  const shortLabel = label?.length > maxChars ? `${label.slice(0, maxChars)}...` : label

  return <ProgressMultiItem
    value={value}
    label={shortLabel}
    className='cursor-pointer'
    tiptap={label}
    {...props}
  />
}

ProgressBar.propTypes = propTypes
ProgressBar.defaultProps = {}
